import moment from "moment";
import {DeviceEvent} from "../../../models/Device.model";
import {EventLabelsMap, PreparedDeviceEvent} from "./EventsTable.model";

export const DEFAULT_EVENT_LABELS: EventLabelsMap = {
  DoorOpened: "Дверь открыли",
  DoorClosed: "Дверь закрыли",
  Shock: "Удар",
  MainGearSensorTriggered: "Сработал датчик на ведущем трибе",
  MinuteGearSensorTriggered: "Сработал датчик на минутной шестерне",
  HourGearSensorTriggered: "Сработал датчик на часовой шестерне",
  IntermediateGearSensorTriggered: "Сработал датчик на промежуточной шестерне",
  ForwardMovementStartedByButton: "Кнопкой запущен ход вперёд",
  BackwardMovementStartedByButton: "Кнопкой запущен ход назад",
  MovementStoppedByButton: "Кнопкой остановлен ход"
};

export const DEFAULT_SENSOR_LABELS: EventLabelsMap = {
  MainGearSensor: "Датчик на главном моторе (ведущий триб)",
  MinuteGearSensor: "Датчик на минутной шестерне",
  HourGearSensor: "Датчик на часовой шестерне",
  IntermediateGearSensor: "Датчик на промежуточной шестерне",
  TemperatureSensor: "Датчик температуры",
  PressureSensor: "Датчик давления",
  HumiditySensor: "Датчик влажности",
  OpeningSensor: "Датчик открытия",
  ShockSensor: "Датчик удара",
  ElectronicClockTemperatureSensor: "Датчик температуры электронных часов",
  StartButton: "Кнопка запуска хода",
  MechanismStartTime: "Время включения механизма",
  VirtualTemperatureSensor: "Виртуальный датчик температуры",
  VirtualPressureSensor: "Виртуальный датчик давления",
  VirtualHumiditySensor: "Виртуальный датчик влажности"
};

export const formatEventTime = (value?: string): string => {
  if (!value) {
    return "-";
  }

  const formattedDate = moment(value).format("DD.MM.YYYY HH:mm:ss");

  return formattedDate === "Invalid date" ? value : formattedDate;
};

// Время события ставит устройство по часам станции; если часы сбились — дата заведомо неверная
const MIN_VALID_TIME = Date.UTC(2020, 0, 1);
const MAX_AHEAD_MS = 24 * 60 * 60 * 1000;

export const isWrongDeviceTime = (value?: string): boolean => {
  if (!value) return false;
  const time = moment(value).valueOf();
  return Number.isFinite(time) && (time < MIN_VALID_TIME || time > Date.now() + MAX_AHEAD_MS);
};

export const prepareEvents = (
  events: DeviceEvent[] = [],
  eventLabels: EventLabelsMap = DEFAULT_EVENT_LABELS,
  sensorLabels: EventLabelsMap = DEFAULT_SENSOR_LABELS
): PreparedDeviceEvent[] => {
  return events.map((item, index) => {
    const sensor = "sensor" in item
      ? item.sensor
      : "sensorCode" in item
        ? item.sensorCode
        : undefined;
    const eventId = "id" in item ? item.id : undefined;

    return {
      ...item,
      id: eventId || `${item.time || "time"}-${sensor || "sensor"}-${item.event || "event"}-${index}`,
      eventLabel: (item.event && eventLabels[item.event]) || item.event || "-",
      sensorLabel: (sensor && sensorLabels[sensor]) || sensor || "-",
      formattedTime: formatEventTime(item.time),
      wrongTime: isWrongDeviceTime(item.time)
    };
  });
};
